import { render, staticRenderFns } from "./BlockType107.vue?vue&type=template&id=4aad538b&scoped=true"
import script from "./BlockType107.vue?vue&type=script&lang=ts"
export * from "./BlockType107.vue?vue&type=script&lang=ts"
import style0 from "./BlockType107.vue?vue&type=style&index=0&id=4aad538b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aad538b",
  null
  
)

export default component.exports